import React from "react";
import { Motion, spring } from "react-motion";

interface OwnProps {
    scrollTop?: number;
}

interface OwnState {
}

export class WindowScrollSink extends React.Component<OwnProps, OwnState> {
    public componentDidUpdate(prevProps: OwnProps) {
        if (typeof document === undefined || document.scrollingElement === null)
            return;

        if (prevProps.scrollTop !== this.props.scrollTop && this.props.scrollTop !== undefined) {
            document.scrollingElement.scrollTop = this.props.scrollTop;
        }
    }

    public render() {
        return null;
    }
}

const renderScrollSink = (props: OwnProps) => {
    return (
        <WindowScrollSink scrollTop={props.scrollTop} />
    );
};

export const WindowMotionScroll = (props: OwnProps) => {
    return (
        <Motion style={{ scrollTop: spring(props.scrollTop || 0)}}>
            {renderScrollSink}
        </Motion>
    );
};



// WEBPACK FOOTER //
// ./src/components/generic/WindowMotionScroll.tsx